import { render, staticRenderFns } from "./PeopleNew.vue?vue&type=template&id=29891838"
import script from "./PeopleNew.vue?vue&type=script&lang=js"
export * from "./PeopleNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports